import {
  BaseFlagProps,
  getColorsFromScheme,
  getFlagElementSizes,
  FlagLabel,
} from 'platform/components';
import {ThemeIconKey, Integer, Icon, Box, Show, Clickable, HStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {Nullish, suffixTestId} from 'shared/web';

interface LegacyFlagProps extends Partial<BaseFlagProps> {
  icon?: ThemeIconKey | Nullish;
  iconPosition?: 'left' | 'right';
  children?: ReactNode;
  onClick?: VoidFunction;
}

export function LegacyFlag({icon, iconPosition, ...props}: LegacyFlagProps) {
  const {backgroundColor, color} = getColorsFromScheme(props.colorScheme, props.isSubtle);
  const {height, labelHorizontalPadding, textSize} = getFlagElementSizes(props.size);

  const iconSize: Integer = props.size === 'small' ? 2 : 3;

  return (
    <Clickable onClick={props.onClick}>
      <Box
        height={height}
        paddingHorizontal={labelHorizontalPadding}
        backgroundColor={backgroundColor}
        borderRadius="xSmall"
        data-testid={suffixTestId('flagWrapper', props)}
      >
        <HStack justify="space-between" align="center" height="100%" spacing={1}>
          <Show when={icon && iconPosition === 'left'}>
            <Icon size={iconSize} color={color} value={icon ?? 'icon_placeholder'} />
          </Show>

          <Show when={props.label}>
            <FlagLabel
              color={color}
              size={textSize}
              label={props.label ?? ''}
              data-testid={props['data-testid']}
            />
          </Show>

          {props.children}

          <Show when={icon && iconPosition === 'right'}>
            <Icon size={iconSize} color={color} value={icon ?? 'icon_placeholder'} />
          </Show>
        </HStack>
      </Box>
    </Clickable>
  );
}
